<template>
	<div class="main_wrap">
		<NavTab />

		<div class="year_calendar">
			<div class="year_box">
				<span class="text_title">预约支队</span>
				<el-select style="width:300px; margin-right:20px;" placeholder="请选择" size="mini" v-model="organizationId" @change="onSelectZhidui">
					<el-option v-for="item in zhiduiLists" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
				</el-select>
				<!-- <el-button class="year_btn" type="danger" plain size="mini" @click="yearClick('clear')">清空选中日期</el-button> -->
				<span class="icon_box" v-if="organizationId">
					<i class="el-icon-d-arrow-left" @click="yearClick('reduce')"></i>
				</span>
				<span class="year_text" v-if="organizationId">{{ currentYear }}年</span>
				<span class="icon_box" v-if="organizationId">
					<i class="el-icon-d-arrow-right" @click="yearClick('add')"></i>
				</span>
				<el-button class="year_btn" type="primary" size="mini" v-if="organizationId" @click="yearClick('current')">切换到今年</el-button>
				<!-- <el-button type="primary" size="mini" @click="onSave">保存设置</el-button> -->
			</div>

			<YearCalendar class="new_case" prefixClass="your_customized_wrapper_class" lang="tw" v-if="organizationId" :showYearSelector="false" 
				v-model="currentYear" :activeClass="activeClass" :activeDates="currentActiveDates" @toggleDate="toggleDate">
			</YearCalendar>
		</div>
	</div>
</template>

<script>
	import YearCalendar from "vue-material-year-calendar" //https://github.com/nono1526/vue-material-year-calendar/blob/master/doc/tw.md
	import { mapState } from "vuex"
	import NavTab from "@/components/navTab.vue" 
	
	export default {
		components: {
			YearCalendar,
			NavTab,
		},
		data: () => ({
			currentYear: new Date().getFullYear(),
			activeClass: "",
			currentActiveDates: [],
			is_active: false,
			organizationId: null,
			zhiduiLists: [],
			daduiLists: [],

		}),
		computed: {
        	
		},
		created() {
			this.getZhiduiLists();
			// this.getDatas();
		},
		mounted() {
			
		},
		methods: {
			// 获取支队列表
			getZhiduiLists() {
				this.$axios.get(`/admin/organization/childrenList/parent-1`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if(code == 0) {
						this.zhiduiLists = data;
					}
				})
			},
            // 获取大队列表
			getDaduiLists(id) {
				this.$axios.get(`/admin/organization/childrenList/parent-${id}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if(code == 0) {
						this.daduiLists = data;
					}
				})
			},
			onSelectZhidui(e) {
                // console.log(e)
                this.getDatas();
            },

			// 回显
			onInit(datas) {
				this.currentActiveDates = [];
				datas.forEach((item) => {
					this.currentActiveDates.push({
						date: item.display,
						className: "blue",
					})
				})
			},
			// 点击日期
			toggleDate(dateInfo) {
				console.log(dateInfo)
				if(this.is_active) return;
				this.is_active = true;
				if (dateInfo.selected) {
					this.currentActiveDates.push({
						date: dateInfo.date,
						className: "blue"
					})
					// 只取两组时间 当选择时间多于2组时 清除第一个
					// this.currentActiveDates.length > 2 ?  this.currentActiveDates.shift() : ''
				} else {
					this.currentActiveDates.splice(
						this.currentActiveDates.findIndex(
							(item) => item.date == dateInfo.date
						),
						1
					) // 再次点击取消选中
				}
				this.onSave(dateInfo.date, dateInfo.selected);
			},
			
			// 切换年份
			yearClick(flag) {
				switch (flag) {
					case "reduce": // 年份减少
						this.currentYear--;
						this.currentActiveDates = [];
						this.getDatas();
						break;
					case "add": // 年份增加
						this.currentYear++;
						this.currentActiveDates = [];
						this.getDatas();
						break;
					case "current": // 实时年份
						if (this.currentYear != new Date().getFullYear()) {
							this.currentYear = new Date().getFullYear();
							this.currentActiveDates = [];
							this.getDatas();
						}
						break;
					case "clear": // 清空选中的日期
						this.currentActiveDates = [];
						break;
					default:
						break;
				}
			},

			getDatas() {
				this.$axios.get(`/holiday/${this.currentYear}/${this.organizationId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.onInit(data);
					} else {
						this.$message.error(msg);
					}
				})
			},

			onSave(date, state) {
				// console.log(this.currentActiveDates)
				console.log(date)
				console.log(state)
				let arr = date.split("-")
				// return
				this.$axios.post(`/set/holiday`, {
					"year": parseInt(arr[0]),
					"month": parseInt(arr[1]),
					"day": parseInt(arr[2]),
					"isHoliday": state,
					"organizationId": this.organizationId,
				}).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					this.is_active = false;
					if (code == 0) {
						this.$message.success("设置成功");
					} else {
						this.$message.error(msg);
					}
				}).catch(err => {
					this.is_active = false;
				})
			},
			

		},
	}
</script>

<style lang="scss" scoped>
	.year_calendar {
		.year_box {
			width: 98%;
			margin: 0 auto 20px;
			padding: 20px 0;
			font-size: 16px;
			text-align: left;
			color: rgb(182, 194, 205);
			background: #fff;

			.text_title {
				margin-left: 20px;
				font-size:14px;
				color:#333;
			}

			.icon_box {
				cursor: pointer;
			}

			.year_text {
				padding: 0 50px;
				font-size: 16px;
				color: #000;
			}

			.year_btn {
				margin: 0 20px;
			}
		}
	}
	.new_case {
		width: 98%;
		margin: 0 auto;
		background: #fff!important;
	}
</style>
<style >
	.blue {
		color: #fff!important;
		background: rgb(31, 160, 254)!important;
	}
</style>


// WEBPACK FOOTER //
// vacation.vue?0f1be754